// extracted by mini-css-extract-plugin
export default {"photoBlock":"TypePhoto_photoBlock__7umyo","textBlock":"TypePhoto_textBlock__WPjYF","textContent":"TypePhoto_textContent__7utlH"};